import React from 'react';
import { makeStyles } from "@material-ui/core/styles";

export default function LoadingSpinner(props) {

  const useStyles = makeStyles({
    spinnerContainer: {
      display: "grid",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100vw",
      position: "fixed",
      top: "0",
      zIndex: "9999",
      backgroundColor: "rgba(0, 0, 0, 0.5)"
    },
    loadingSpinner: {
      width: "50px",
      height: "50px",
      border: "10px solid #ff0000",
      borderTop: "10px solid transparent",
      borderRadius: "50%",
      animation: "spinner 1.5s linear infinite"
    }
  });

  const classes = useStyles();

  return (
    <div className={classes.spinnerContainer}>
      <div className={classes.loadingSpinner}>
      </div>
    </div>
  );
}